module Eseebase {
    export interface IAutocompleteMultiselectScope extends ng.IScope {
        model: any[];
        collection: any;
        valueMember: any;
        copyCollection: Function;
        compareCollections: Function;
        selectItem: Function;
        onValueChanged: Function;
        textMember: any;
        sortBy: string;
        descending: string;
        ngDisabled: boolean;
        onChanged: Function;
        getMatches: Function;
        searchText: string;
        selectedItem: any;
        searchMode: boolean;
        onOpen: Function;
        onKeydown: Function;
        autocmpleteItemSelected: Function;
        getDisplayText: Function;
        getItemText: Function;
        onBlur: Function;
        loading: boolean;
        oldModel: any[];
    }

    export class AutocompleteMultiselectDirective {
        public link: (scope: IAutocompleteMultiselectScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;
        public templateUrl = '/app/directives/autocomplete-multiselect.html';
        public scope = {
            model: '=',
            collection: '=',
            valueMember: '=',
            textMember: '=',
            sortBy: '=',
            descending: '=',
            ngDisabled: '=',
            onChanged: '&',
            loading: '='
        };
        public restrict = 'E';
        public replace: any;

        constructor(private $http: ng.IHttpService, private $mdDialog: any, private $timeout: ng.ITimeoutService, private $filter: any) {
            var vm = this;
            AutocompleteMultiselectDirective.prototype.restrict = 'E';
            AutocompleteMultiselectDirective.prototype.replace = 'true';
            AutocompleteMultiselectDirective.prototype.scope = { model: '=', collection: '=', valueMember: '=', textMember: '=', onChanged: '&', sortBy: '=', descending: '=', ngDisabled: '=', loading: '=' };
            AutocompleteMultiselectDirective.prototype.link = (scope: IAutocompleteMultiselectScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {

                scope.searchMode = false;
                scope.$watch((sc) => scope.model, (newval, oldval) => {
                    if (newval == null && scope.collection != null && scope.collection.length == 1) {
                        scope.model = scope.valueMember != '' ? [scope.collection[0][scope.valueMember]] : [scope.collection[0]];
                        $timeout(() => {
                            scope.onChanged();
                        }, 100);
                        
                    }
                }, true);
                //scope.$watch((sc) => scope.collection, () => {
                //    if (scope.collection == null || scope.collection.length == 0) {
                //        return;
                //    }
                //    var newCollection = [];
                //    scope.copyCollection(newCollection);
                //    if (scope.sortBy != null && scope.sortBy != '') {
                //        scope.collection = $filter('orderBy')(newCollection, scope.sortBy, scope.descending);
                //    }
                //    else {
                //        scope.collection = newCollection;
                //    }
                //}, true);
                element.on('mousedown', function (e) {
                    //e.preventDefault();
                    //e.stopPropagation();
                    //e.stopImmediatePropagation();
                    //e.cancelBubble = true;
                    //return false;
                });
                element.on('mouseup', function (e) {
                    //e.preventDefault();
                    //e.stopPropagation();
                    //e.stopImmediatePropagation();
                    //e.cancelBubble = true;
                    //return false;
                });
                element.on('click', function (e) {
                    //e.preventDefault();
                    //e.stopPropagation();
                    //e.stopImmediatePropagation();
                    //e.cancelBubble = true;
                    //return false;
                });

                $('md-virtual-repeat-container').on('click', (evt) => {
                    evt.stopImmediatePropagation();
                    evt.stopPropagation;
                    evt.cancelBubble = true;
                });

                scope.copyCollection = function (newCollection: any[]) {
                    if (scope.model == null) {
                        return;
                    }
                    for (var item of scope.model) {
                        if (scope.valueMember != '') {

                            if (newCollection.filter(f => f[scope.valueMember] == item).length == 0) {
                                newCollection.push(item);
                            }
                        }
                        else {
                            if (newCollection.indexOf(item) == -1) {
                                newCollection.push(item);
                            }
                        }
                    }
                }

                scope.compareCollections = function (collection1: any[], collection2: any[]) {
                    if (collection1 == null || collection2 == null || collection1.length != collection2.length) {
                        return false;                         
                    }
                    for (var c1 of collection1) {
                        if (collection2.indexOf(c1) == -1) {
                            return false;
                        }
                    }

                    for (var c2 of collection2) {
                        if (collection1.indexOf(c2) == -1) {
                            return false;
                        }
                    }
                    return true;
                }

                scope.selectItem = function (item: any) {
                    if (scope.model == null) {
                        scope.model = [];
                    }
                    var itemId = (scope.valueMember != '') ? item[scope.valueMember] : item;
                    var modelIndex = scope.model.indexOf(itemId);
                    if (modelIndex == -1) {
                        scope.model.push(itemId);
                    }
                    else {
                        scope.model.splice(modelIndex, 1);
                    }
                }
                
                scope.getMatches = function (query) {
                    var items = scope.collection;
                    return query ? items.filter(item => ((item.hasOwnProperty('number') ? item.number : item).toLowerCase().indexOf(query.toLowerCase()) > -1 || (item.hasOwnProperty('name') ? item.name : item).toLowerCase().indexOf(query.toLowerCase()) > -1) && (scope.model == null || scope.model.indexOf(item.id) == -1)) : items.filter(item => (scope.model == null || scope.model.indexOf(item.id) == -1));
                }

                scope.autocmpleteItemSelected = function () {
                    if (scope.selectedItem != null) {
                        if (scope.selectedItem.checked == null) {
                            scope.selectedItem.checked = false;
                        }
                        scope.selectedItem.checked = !scope.selectedItem.checked;
                        scope.selectItem(scope.selectedItem);
                    }
                    scope.selectedItem = null;
                    scope.onChanged();
                    //scope.searchMode = false;
                }

                scope.getDisplayText = function (emptyText: string, template: string) {
                    if (scope.model == null || scope.model.length == 0) {
                        return emptyText;
                    }
                    else if (scope.model.length == 1) {
                        if (scope.valueMember != '') {
                            var it = scope.collection.filter(m => m[scope.valueMember] == scope.model[0])[0];
                            if (it != null && scope.textMember != '' && it[scope.textMember] != null) {
                                return it[scope.textMember];
                            }
                            else {
                                return it;
                            }
                        }
                        else {
                            return scope.model[0];
                        }
                    }
                    else if (scope.model.length > 1) {
                        return template.replace(/\{0\}/g, scope.model.length.toString());
                    }
                }

                scope.onValueChanged = function () {
                    if (scope.compareCollections(scope.oldModel, scope.model)) {
                        return;
                    }
                    var cnt = 0;
                    if (scope.model == null) {
                        return;
                    }
                    for (var item of scope.collection) {
                        var itemId = (scope.valueMember != '') ? item[scope.valueMember] : item;
                        if (scope.model.indexOf(itemId) > -1) {
                            item.checked = true;
                            cnt++;
                        }
                        else {
                            item.checked = false;
                        }
                    }
                    scope.onChanged();
                }

                scope.onKeydown = function (e) {
                    var keyCode = e.which || e.keyCode;
                    var isTyping = (keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122);
                    if (isTyping){
                        $(element).find('.md-select-value').hide();
                        scope.searchMode = true;
                        vm.$timeout(() => {
                            var input = $(element).find('md-autocomplete input');
                            input.val(String.fromCharCode(keyCode).toLowerCase());
                            input.focus();
                            input.on('blur', function (ev) {
                                $(element).find('md-select md-select-value').show();
                                vm.$timeout(() => {
                                    scope.searchMode = false;
                                }, 10);
                            });
                        }, 100);
                    }
                }

                scope.onOpen = function (e) {
                    var posX = e.pageX - $(element).offset().left,
                        posY = e.pageY - $(element).offset().top,
                        fieldWidth = $(element).width(),
                        openerWidth = $(element).find('.md-select-icon').width();

                    //scope.oldModel = scope.model;
                    if (scope.collection != null && scope.sortBy != null && scope.sortBy != '') {
                        //scope.collection = $filter('orderBy')(scope.collection, scope.sortBy, scope.descending);
                        scope.collection = HelperService.SortArray(scope.collection, scope.sortBy);
                        scope.oldModel = [];
                        scope.copyCollection(scope.oldModel);
                    }
                    if (scope.collection != null && scope.collection.length > 0 && posX < fieldWidth - openerWidth) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        $(element).find('.md-select-value').hide();
                        scope.searchMode = true;
                        vm.$timeout(() => {
                            var input = $(element).find('md-autocomplete input');
                            input.focus();
                            input.on('blur', function (ev) {
                                $(element).find('md-select md-select-value').show();
                                vm.$timeout(() => {
                                    scope.searchMode = false;
                                }, 10);
                            });
                        }, 100);
                        
                        //var input = $('<input class="md-title ng-pristine md-input" style="margin:0;padding:0;border:0;"/>');
                        //var inputContainer = $('<md-input-container class="md-icon-float" style="margin:0;padding:0;border:0;"></md-input-container>');
                        //inputContainer.append(input).insertAfter($(element));
                        //if ((scope.searchText == null || scope.searchText == '') && scope.model != null) {
                        //    scope.searchText = scope.model.join();;
                        //}
                        //input.val(scope.searchText);
                        //input.focus();
                        //input.on('blur', function (ev) {
                        //    vm.$timeout(() => {
                        //        scope.searchText = scope.updateModel(input.val());
                        //        inputContainer.remove();
                        //        $(element).find('.md-select-value').show();
                        //    });
                        //});
                        
                        return false;
                    }
                    else {
                        $(element).find('.md-select-value').show();
                        scope.searchMode = false;
                    }
                    return true;
                }

                scope.getItemText = function (item) {
                    return item.hasOwnProperty('name') ? item.name : item;
                }

                scope.onBlur = function () {
                    if (scope.selectedItem == null && scope.searchText != null && scope.searchText != '') {
                        if (scope.valueMember != '') {
                            scope.selectedItem = scope.collection.filter(m => m.name == scope.searchText || m.number == scope.searchText)[0];
                        }
                        else {
                            scope.selectedItem = scope.collection.filter(m => m == scope.searchText)[0];
                        }
                        if (scope.selectedItem != null) {
                            scope.onChanged();
                        }
                    }
                }
            };
        }

        public static Factory() {
            var directive = ($http: ng.IHttpService, $mdDialog: any, $timeout: ng.ITimeoutService, $filter: any) => {
                return new AutocompleteMultiselectDirective($http, $mdDialog, $timeout, $filter);
            };

            directive['$inject'] = ['$http', '$mdDialog', '$timeout', '$filter'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('autocompleteMultiselect', AutocompleteMultiselectDirective.Factory());
}